import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PostCodeValidator {
  constructor() {}

  postcodeValidator(
    formField: AbstractControl
  ): { [key: string]: any } | null | void {
    // Check if field is Required
    const isEmpty = (formField.value === '') || (formField.value === null) || (formField.value === undefined);
    // if (isEmpty) {
    //   return { required: { valid: false, value: formField.value } };
    // }

    // Must only be numbers
    const isAllNumbers = /^[0-9]+$/.test(formField.value);
    if (!isEmpty && !isAllNumbers) {
      return { notAllNumbers: { valid: false, value: formField.value } };
    }

    // Minimun 4 digits
    const notEnough = /^\d( ?\d){0,2}$/.test(formField.value);
    if (!isEmpty && notEnough) {
      return { min: { valid: false, value: formField.value } };
    }

    // Maximun 4 digits
    const tooMany = /^\d( ?\d){4,}$/.test(formField.value);
    if (!isEmpty && tooMany) {
      return { max: { valid: false, value: formField.value } };
    }

    // Must be Australian Postcode
    const isPostcode = /^$|^[0-9]{4}$/.test(formField.value);
    if (!isEmpty && !isPostcode) {
      return { notPostcode: { valid: false, value: formField.value } };
    }
  }
}
